<ng-container *ngIf="!isAnalytics">
  <div style="display: flex; justify-content: space-between">
    <h2
      mat-dialog-title
      style="
        position: relative;
        color: #121212 !important;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      "
      title="{{ title }}"
    >
      {{ title }}
    </h2>
    <button class="close-button" title="close" (click)="onNoClick()">x</button>
  </div>
  <hr />
  <mat-dialog-content>
    <div style="width: 100%">
      <canvas
        baseChart
        [data]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [legend]="barChartLegend"
        [type]="barChartType"
      >
      </canvas>
    </div>
    <div style="display: flex; column-gap: 15px; margin-top: 15px">
      <div style="font-size: 24px">
        <i
          aria-hidden="true"
          class="fa fa-thumbs-up"
          style="color: #5a5a5a; margin: 5px 5px; cursor: pointer"
          title="Useful"
        ></i>
        {{ thumbsUpCount }}
      </div>
      <div style="font-size: 24px">
        <i
          aria-hidden="true"
          class="fa fa-thumbs-down"
          style="color: #5a5a5a; margin: 5px 5px; cursor: pointer"
          title="Needs improvement"
        ></i>
        {{ thumbsDownCount }}
      </div>
    </div>
  </mat-dialog-content>
</ng-container>

<ng-container *ngIf="isAnalytics">
  <mat-dialog-content>
    <div style="display: flex; justify-content: space-between">
      <h2
        mat-dialog-title
        style="
          position: relative;
          color: #121212 !important;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        "
        title="{{ analyticsChartTitle }}"
      >
        {{ analyticsChartTitle }}
      </h2>
      <button class="close-button" title="close" (click)="onNoClick()">
        &times;
      </button>
    </div>
    <hr />
    <div style="width: 100%">
      <canvas
        baseChart
        [data]="chartData"
        [type]="chartType"
        [options]="chartOptions"
        [legend]="chartLegend"
      >
      </canvas>
    </div>
  </mat-dialog-content>
</ng-container>
